import React from 'react';
import { CContainer, CBreadcrumb, CBreadcrumbItem, CCard, 
  CCardHeader, CCardBody, CRow, CCol } from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import OrderInputs from '../../components/OrderInputs/OrderInputs';
import { updateOrderRequest } from '../../store/order/orderActions';

const UpdateOrder = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoading = useSelector(state => state.orderReducer.isLoading);
  const submitResponse = useSelector(state => state.orderReducer.updateOrderData);
  const initialData = location.state?.order || null;

  const handleSubmit = (data) => {
    dispatch(updateOrderRequest({ ...data, navigate }));
  };

  const handleCancel = () => {
    navigate('/orders');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/orders" onClick={e => 
          { e.preventDefault(); handleCancel(); }}>{t('orders')}</CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateOrder')}</CBreadcrumbItem>
      </CBreadcrumb>
      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('updateOrder')}</h4></CCardHeader>
            <CCardBody>
              <OrderInputs onSubmit={handleSubmit} 
              onCancel={handleCancel} isLoading={isLoading} 
              submitResponse={submitResponse} initialData={initialData} isEdit />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default UpdateOrder; 